/** Copy more than one mission uses. */

/** The last line of every "If it doesn't": the way out is always to flag us. */
export const FLAG_US = {
  symptom: 'Still stuck.',
  say: 'Write me a note for cpg.computer about this, then use "Flag us" in your dashboard.',
}

/** The four parts of a good ask (recipe "What your agent can and can't do"). */
export const GOOD_ASK = `**The four parts of a good ask.** Your agent does its best work when you say all four:

- **The job**: what it's for. "I decide who to call on Mondays."
- **The data**: where the numbers come from. Shopify, a file you attach, or another service with a key.
- **Your rule**: what counts. "Quiet means no order in six weeks."
- **Who looks**: you, your team, or an investor. That decides what it shows and what it hides.`

/** "Only X is saved", for the "How this page knows" card. */
export const savedOnly = (title: string) =>
  `Only "${title}: done" is saved, with the time, to your own record at cpg.computer. What you changed never leaves your app.`

/** For missions the page can't see: the founder ticks them. */
export const selfTick = (title: string, why: string) => `${why} So you tick it yourself with "I did it". ${savedOnly(title)}`
